export const FILE_TYPE_ICONS = {
  // Images
  'image/png': ['fas', 'file-image'],
  'image/jpeg': ['fas', 'file-image'],
  'image/jpg': ['fas', 'file-image'],
  'image/gif': ['fas', 'file-image'],
  'image/svg+xml': ['fas', 'file-image'],
  'image/bmp': ['fas', 'file-image'],
  'image/x-icon': ['fas', 'file-image'],

  // Videos
  'video/mp4': ['fas', 'file-video'],
  'video/avi': ['fas', 'file-video'],
  'video/quicktime': ['fas', 'file-video'],
  'video/x-msvideo': ['fas', 'file-video'],

  // Documents
  'application/pdf': ['fas', 'file-pdf'],
  'application/msword': ['fas', 'file-alt'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['fas', 'file-alt'],
  'application/vnd.ms-excel': ['fas', 'file-alt'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['fas', 'file-alt'],
  'application/vnd.ms-powerpoint': ['fas', 'file-alt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['fas', 'file-alt'],

  // Archives
  'application/zip': ['fas', 'file-archive'],
  'application/x-tar': ['fas', 'file-archive'],
  'application/gzip': ['fas', 'file-archive'],
  'application/x-7z-compressed': ['fas', 'file-archive'],
  'application/x-rar-compressed': ['fas', 'file-archive'],
  'application/x-bzip2': ['fas', 'file-archive'],

  // Code/Text
  'text/plain': ['fas', 'file-lines'],
  'text/html': ['fas', 'file-code'],
  'text/javascript': ['fas', 'file-code'],
  'application/json': ['fas', 'file-code'],
  'text/csv': ['fas', 'file-lines'],
  'application/xml': ['fas', 'file-code'],
  'text/xml': ['fas', 'file-code'],
  'text/css': ['fas', 'file-code'],

  // Network
  'application/vnd.tcpdump.pcap': ['fas', 'file-code'],
  'application/x-pcapng': ['fas', 'file-code'],

  // Executables
  'application/x-dosexec': ['fas', 'file-code'],
  'application/x-executable': ['fas', 'file-code'],
  'application/x-sharedlib': ['fas', 'file-code'],

  // Default
  'default': ['fas', 'file']
}

export const FILE_TYPE_COLORS = {
  'image': '#22c55e',
  'video': '#a855f7',
  'pdf': '#ef4444',
  'document': '#3b82f6',
  'archive': '#f59e0b',
  'code': '#14b8a6',
  'text': '#6b7280',
  'network': '#8b5cf6',
  'executable': '#dc2626',
  'default': '#9ca3af'
}

/**
 * Get Font Awesome icon for a file
 * @param {File|Object} file - File object or object with type property
 * @returns {Array} Font Awesome icon array [prefix, iconName]
 */
export function getFileIcon(file) {
  const type = file.type || ''
  return FILE_TYPE_ICONS[type] || FILE_TYPE_ICONS['default']
}

/**
 * Get color for a file type
 * @param {File|Object} file - File object or object with type property
 * @returns {string} Hex color code
 */
export function getFileColor(file) {
  const type = file.type || ''

  if (type.startsWith('image/')) return FILE_TYPE_COLORS.image
  if (type.startsWith('video/')) return FILE_TYPE_COLORS.video
  if (type === 'application/pdf') return FILE_TYPE_COLORS.pdf
  if (type.includes('document') || type.includes('word') || type.includes('excel') || type.includes('powerpoint')) {
    return FILE_TYPE_COLORS.document
  }
  if (type.includes('zip') || type.includes('archive') || type.includes('tar') || type.includes('gzip') || type.includes('rar') || type.includes('7z')) {
    return FILE_TYPE_COLORS.archive
  }
  if (type.includes('json') || type.includes('javascript') || type.includes('html') || type.includes('css') || type.includes('xml')) {
    return FILE_TYPE_COLORS.code
  }
  if (type.startsWith('text/')) return FILE_TYPE_COLORS.text
  if (type.includes('pcap')) return FILE_TYPE_COLORS.network
  if (type.includes('executable') || type.includes('dosexec')) return FILE_TYPE_COLORS.executable

  return FILE_TYPE_COLORS.default
}

/**
 * Format file size to human-readable format
 * @param {number} bytes - File size in bytes
 * @returns {string} Formatted file size (e.g., "1.5 MB")
 */
export function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i]
}

/**
 * Get file extension from filename
 * @param {string} filename - File name
 * @returns {string} File extension in uppercase (e.g., "PDF")
 */
export function getFileExtension(filename) {
  if (!filename) return 'FILE'

  const parts = filename.split('.')
  if (parts.length > 1) {
    return parts[parts.length - 1].toUpperCase()
  }

  return 'FILE'
}
